import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Home from "./pages/Home";
import Membership from "./pages/Membership";
import Events from "./pages/Events";
import PastEvents from "./pages/PastEvents";
import Culture from "./pages/Culture";
import International from "./pages/International";
import Trade from "./pages/Trade";
import NotFound from "./pages/NotFound";

const router = createBrowserRouter([
  { path: "/", element: <Home />, errorElement: <NotFound /> },
  { path: "/membership", element: <Membership /> },
  { path: "/events", element: <Events /> },
  { path: "/past-events", element: <PastEvents /> },
  { path: "/cultural-exchange", element: <Culture /> },
  { path: "/international-education", element: <International /> },
  { path: "/trade-missions-and-delegations", element: <Trade /> },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
